"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentSignatureType = void 0;
var DocumentSignatureType;
(function (DocumentSignatureType) {
    DocumentSignatureType["text"] = "text";
    DocumentSignatureType["image"] = "image";
})(DocumentSignatureType || (exports.DocumentSignatureType = DocumentSignatureType = {}));
